export let REGION = "ap-south-1";
export let ACCESS_KEY = "AKIAY2YS5NFNTUKGZ7MJ";
export let SECRET_KEY = "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";
export const BUCKET_NAME = "tia-web-site";
